import { Component, Input } from '@angular/core';
import { TableRow } from '../../models/table-row.model';
import { SmTableComponent } from '../sm-table/sm-table.component';
import { FrontendForm } from '../../netgen/FrontendForm';
import { FrontendField } from '../../netgen/FrontendField';

@Component({
    selector: 'app-sm-table-row-editor-form',
    templateUrl: './sm-table-row-editor-form.component.html',
    styleUrl: './sm-table-row-editor-form.component.scss',
    standalone: false
})
export class SmTableRowEditorFormComponent {

  @Input()
  table: SmTableComponent;
  @Input()
  row: TableRow;
  @Input()
  rowIndex: number;

  form: FrontendForm;

  update(): void {
   // this.form = new FrontendFormDefinition(this.table.colDefs.map(colDef => this.columnToField(colDef)));  
  }

}